import { External } from "components/icons/generated";
import { projectRootTooltipContent } from "components/TooltipSnippets";

import TableCellLink, { TableCellLinkProps } from "./CellLink";

type TableCellProjectRootProps = TableCellLinkProps;

const TableCellProjectRoot = (props: TableCellProjectRootProps) => {
  return (
    <TableCellLink
      variant="primary"
      target="_blank"
      endIcon={External}
      tooltip={projectRootTooltipContent}
      {...props}
    />
  );
};

TableCellProjectRoot.displayName = "DS.Table.CellProjectRoot";

export default TableCellProjectRoot;
